import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import ShareYourTwoCentsViewContent from '../../../components/Pages/ShareYourTwoCents/View';

const { displayName } = config;

export default function ShareYourTwoCentsView(): React.ReactElement {
  document.title = `${displayName}: Share Your Two Cents`;

  return (
    <Layout>
      <ShareYourTwoCentsViewContent />
    </Layout>
  );
}
